import * as color from 'color';
export const Color = color;
